var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"letters",class:{
    standby:
      !this.started ||
      this.stage !== 'play' ||
      this.attempts === 0 ||
      _vm.length === 0,
  }},_vm._l((_vm.alphabetOptions),function(letter,index){return _c('div',{key:index,staticClass:"alphabet"},[_c('button',{class:[
        'btn btn-action s-circle',
        {
          button: letter.choice,
          disabled: letter.chosen,
          loading: letter.status == 'loading',
        } ],on:{"click":function($event){(letter.status = 'loading'),
          _vm.bringTreeIntoView(letter.choice, letter.chosen, letter.status)}}},[_c('b',{class:{ selected: letter.chosen }},[_vm._v(_vm._s(letter.choice))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }